import React, { useEffect, useRef, useState } from "react";
import { QR_ROWS, QR_SIZE, QR_TARGET } from "../data/qrMatrix";

/* The code in the hero is the real one. It scans to the demo, so the first
   thing on the page is the product rather than a picture of the product. */
function Code() {
  const boxRef = useRef(null);

  useEffect(() => {
    const el = boxRef.current;
    if (!el) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      el.style.setProperty("--qry", `${(-x * 20 - 6).toFixed(2)}deg`);
      el.style.setProperty("--qrx", `${(y * 16 + 4).toFixed(2)}deg`);
    };
    const onLeave = () => {
      el.style.setProperty("--qry", "-13deg");
      el.style.setProperty("--qrx", "9deg");
    };
    el.addEventListener("pointermove", onMove);
    el.addEventListener("pointerleave", onLeave);
    return () => {
      el.removeEventListener("pointermove", onMove);
      el.removeEventListener("pointerleave", onLeave);
    };
  }, []);

  const mods = [];
  let i = 0;
  const hole = [Math.floor(QR_SIZE / 2) - 3, Math.floor(QR_SIZE / 2) + 3];
  for (let r = 0; r < QR_SIZE; r += 1) {
    for (let c = 0; c < QR_SIZE; c += 1) {
      if (QR_ROWS[r][c] !== "1") continue;
      // the middle is covered by the mark, so those modules are never drawn
      if (r >= hole[0] && r <= hole[1] && c >= hole[0] && c <= hole[1]) continue;
      // each module flies in from a little way out, seeded off its position so
      // the assembly looks scattered rather than swept
      const a = ((r * 31 + c * 17) % 360) * (Math.PI / 180);
      mods.push(
        <rect
          key={`${r}-${c}`}
          className="m"
          x={c}
          y={r}
          width="1"
          height="1"
          rx="0.22"
          style={{
            "--i": i,
            "--dx": `${(Math.cos(a) * 9).toFixed(1)}px`,
            "--dy": `${(Math.sin(a) * 9).toFixed(1)}px`,
          }}
        />
      );
      i += 1;
    }
  }

  return (
    <div>
      <a
        className="qr"
        ref={boxRef}
        href="/demo/"
        aria-label="Scan or click to open the demo"
      >
        <svg viewBox={`0 0 ${QR_SIZE} ${QR_SIZE}`} shapeRendering="crispEdges" aria-hidden="true">
          <g fill="#08090b">{mods}</g>
        </svg>
        <span className="qr__badge">
          <img src="/logo-glyph-white.png" alt="" />
        </span>
      </a>
      <p className="qr__cap micro">Point a camera at this, or click it</p>
    </div>
  );
}

export default function Hero() {
  const [lit, setLit] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setLit(true), 1250);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="hero" id="home">
      <div className="hero__bg" aria-hidden="true" />
      <div className="shell hero__in">
        <div>
          <span className="eyebrow">Scan to insight</span>
          <h1 className="h-xl">
            <span className="ln">Someone just chose your brand.</span>
            <span className={`ln turn${lit ? " lit" : ""}`}>You have no idea who.</span>
          </h1>
          <p className="lede">
            SipNScore turns the moment a person picks up, pours, tastes or buys
            your product into a record you own. They point their own phone at a
            code, answer a few questions you wrote, and take something for it.
          </p>
          <div className="hero__cta">
            <a className="btn" href="/demo/">
              Be the guest for 60 seconds
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h13M13 6l6 6-6 6" />
              </svg>
            </a>
            <a className="btn btn--ghost" href="#arc">See how it runs</a>
          </div>
          <div className="hero__note micro">
            <span>No app</span>
            <span>No account</span>
            <span>Consent first</span>
          </div>
        </div>
        <Code target={QR_TARGET} />
      </div>
    </section>
  );
}
